import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomBaseQuery } from "./customBaseQuery";

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL!.replace(/\/$/, "");

export const publishApi = createApi({
  reducerPath: "publishApi",
  baseQuery: createCustomBaseQuery(`${API_BASE_URL}/publish/`),
  endpoints: (builder) => ({
    // 🔹 Build and publish app
    buildAndPublish: builder.mutation<any, { app_project_id: string; version_id: string }>({
      query: ({ app_project_id, version_id }) => ({
        url: "build-and-publish",
        method: "POST",
        body: { app_project_id, version_id },
      }),
    }),

    // 🔹 Unpublish app
    unpublishApp: builder.mutation<any, { app_project_id: string }>({
      query: ({ app_project_id }) => ({
        url: "unpublish-app",
        method: "POST",
        body: { app_project_id },
      }),
    }),
  }),
});

export const {
  useBuildAndPublishMutation,
  useUnpublishAppMutation,
} = publishApi;
